import { render, staticRenderFns } from "./payment-records.vue?vue&type=template&id=1d52a8e2&scoped=true&"
import script from "./payment-records.vue?vue&type=script&lang=js&"
export * from "./payment-records.vue?vue&type=script&lang=js&"
import style0 from "./payment-records.vue?vue&type=style&index=0&id=1d52a8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52a8e2",
  null
  
)

export default component.exports